import React from "react";
import Page from "../templates/empower/wellbeing/wellbeing-page";
import { Helmet } from "react-helmet";

export default function home() {
  return (
    <div>
      <Helmet>
        <title>Employee Wellbeing | Care and Trust | Hirdaramani</title>
        <meta
          name="title"
          content="Employee Wellbeing | Care and Trust | Hirdaramani"
        />
        <meta
          name="description"
          content="Join us in championing wellbeing with Hirdaramani's WOW program, empowering employees across our footprint."
        />
        <link
          rel="canonical"
          href="https://sustainability.hirdaramani.com/empower/wellbeing/"
        />
        <meta property="og:locale" content="en_US" />
        <meta name="keywords" content="Employee Wellbeing" />
        <meta
          property="og:title"
          content="Employee Wellbeing | Care and Trust | Hirdaramani"
        />
        <meta
          property="og:description"
          content="Join us in championing wellbeing with Hirdaramani's WOW program, empowering employees across our footprint."
        />
        <meta
          property="og:image"
          content="https://hirdaramani-microsite.sgp1.digitaloceanspaces.com/images/logo.png"
        />
        <meta
          property="og:url"
          content="https://sustainability.hirdaramani.com/empower/wellbeing/"
        />
      </Helmet>

      <Page />
    </div>
  );
}
